interface IExchangeLocalPriceParams {
	rates?: any
	price: number | string
	warehouse: string
	count: number
	floatMin?: number
	floatMax?: number
}

interface IGetCurrencySymbolOriginalParams {
	supportedCurrencies?: any
	warehouseIdMap?: any
	warehouse: string
}

interface IGetformatFloatPriceParams {
	price: number
	floatMin?: number
	floatMax?: number
}

function exchangeLocalPrice(params: IExchangeLocalPriceParams) {
	const { rates, price, warehouse, count, floatMin, floatMax } = params

	if (rates) {
		const result = rates[warehouse] * Number(price) * count
		return getformatFloatPrice({ price: result, floatMin, floatMax })
	}
	return ''
}

function getCurrencySymbolOriginal(params: IGetCurrencySymbolOriginalParams) {
	const { supportedCurrencies, warehouseIdMap, warehouse } = params
	if (!supportedCurrencies || !warehouseIdMap) return ''
	if (!warehouseIdMap[warehouse]) return ''
	if (warehouseIdMap[warehouse].currency === undefined) return ''
	const { currency } = warehouseIdMap[warehouse]
	return supportedCurrencies[currency.toLowerCase()].symbol
}

function getformatFloatPrice(params: IGetformatFloatPriceParams) {
	const { price, floatMin = 0, floatMax = 2 } = params
	let result = price

	if (result < 1) {
		result = 1
	}
	result = +Number(result).toFixed(floatMax)
	return `${
		window.BUYANDSHIP.settings.current_country2.currency_symbol
	} ${result.toLocaleString('en', {
		minimumFractionDigits: floatMin,
		maximumFractionDigits: floatMax,
	})}`
}

export { exchangeLocalPrice, getformatFloatPrice, getCurrencySymbolOriginal }
